import React, { memo } from "react";
import PropTypes from "prop-types";
import Button from "../../../shared/button";

const SearchInput = ({
    isHomePage,
    inputSearchValue,
    handleInputChange,
    handleFocus,
    handleOnKeyDown,
    totalAvailableCars,
    onShowButtonClickHandler
}) => {
    return (
        <React.Fragment>
            <input
                type="text"
                placeholder="Search cars by model"
                onChange={handleInputChange}
                onFocus={handleFocus}
                value={inputSearchValue}
                onKeyPress={handleOnKeyDown}
            />
            {isHomePage && (
                <Button
                    text={`view all ${totalAvailableCars || ""} cars`}
                    onClick={onShowButtonClickHandler}
                    isUpperCase
                />
            )}
        </React.Fragment>
    );
};

SearchInput.propTypes = {
    isHomePage: PropTypes.bool.isRequired,
    inputSearchValue: PropTypes.string,
    handleInputChange: PropTypes.func.isRequired,
    handleFocus: PropTypes.func.isRequired,
    handleOnKeyDown: PropTypes.func.isRequired,
    totalAvailableCars: PropTypes.number,
    onShowButtonClickHandler: PropTypes.func.isRequired
};

export default memo(SearchInput);
